import { useContext } from 'react';
import { FlexContext } from '../../../contexts/flexContext';
import { AppContext } from '../../../contexts/appContext';
import { IStructuredSnowplowEvent } from '../../useSnowplowTracker';
import useNavigation from '../../useNavigation';

export interface IFlexNavigateFinish {
  type: 'finish';
  relaunch: boolean;
  urlToOpen?: string;
  snowplowEvent?: IStructuredSnowplowEvent;
}

const useFlexNavigateFinish = () => {
  const { reinitializeApp } = useContext(AppContext);
  const flexContext = useContext(FlexContext);
  const navigation = useNavigation();

  const handleFlexNavigateFinish = (flexNavigate: IFlexNavigateFinish) => {
    // Relaunch the app if instructed.
    if (flexNavigate.relaunch && !flexNavigate.urlToOpen) {
      reinitializeApp();
      return;
    }

    if (flexNavigate.relaunch && flexNavigate.urlToOpen) {
      flexContext.finish(flexNavigate.urlToOpen);
      return;
    }

    // When a flex flow's start returns a finish, this runs inside FlexContextProvider,
    // so flexContext.finish is the empty default (a component can't read its own context).
    // There's nothing to pop back to, so navigate forward to the target instead.
    if (!flexContext.finish) {
      if (flexNavigate.urlToOpen) {
        navigation.redirectToPath(flexNavigate.urlToOpen);
      } else {
        reinitializeApp();
      }
      return;
    }

    flexContext.finish(flexNavigate.urlToOpen);
  };

  return handleFlexNavigateFinish;
};

export default useFlexNavigateFinish;
